import { appendAkamaiHeaders } from 'lib/utilities/akamaiHeaders';
import { logError, logInfo } from 'lib/utilities/logger';

export default async function getNavigationFile(locale, config, logId) {
	const unexpectedErrorMessage = 'Sorry an unexpected error has occurred';

	try {
		const { baseUrl, brand } = config;
		const lowerCaseBrand = brand.code.toLowerCase();
		const lowerCaseMarket = locale.market.toLowerCase();
		const lowerCaseLanguage = locale.language.toLowerCase();
		const urlNavigationFile = `${baseUrl}/content/dam/royal/g11n/universal-navigation/${lowerCaseBrand}-${lowerCaseMarket}-${lowerCaseLanguage}.json`;

		logInfo('Requesting navigation file', {
			urlNavigationFile,
			logId,
		});

		const response = await fetch(urlNavigationFile, {
			method: 'GET',
			headers: appendAkamaiHeaders({
				Accept: 'application/json',
			}),
		});

		if (!response.ok) {
			logError('Error in getNavigationFile. A response other than 200 was received', {
				responseStatus: response.status,
				logId,
				requestedFile: urlNavigationFile,
			});
			throw new Error(unexpectedErrorMessage);
		} else {
			return response.json();
		}
	} catch (error) {
		if (error.message !== unexpectedErrorMessage) {
			logError('Universal Navigation Fetch error - ', { error, logId });
		}
	}
}
